import { useSession, signOut } from "../../lib/auth";
import { useNavigate, Link } from "@tanstack/react-router";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@wondermaps/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/pro-solid-svg-icons/faUser";
import { faRightFromBracket } from "@fortawesome/pro-solid-svg-icons/faRightFromBracket";

export function SuperadminUserMenu() {
  const { data: session } = useSession();
  const navigate = useNavigate();

  const userEmail = session?.user?.email ?? "";
  const userInitial = userEmail.charAt(0).toUpperCase() || "?";

  const handleSignOut = async () => {
    await signOut();
    navigate({ to: "/login", search: { redirect: window.location.pathname } });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="h-10 w-10 rounded-full flex items-center justify-center hover:bg-accent/50 transition-colors">
          <div className="h-7 w-7 rounded-full bg-foreground text-background flex items-center justify-center text-xs font-medium">
            {userInitial}
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <div className="px-2 py-1.5">
          <p className="text-sm font-medium truncate">{userEmail}</p>
        </div>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link
            to="/account"
            className="flex items-center gap-2 cursor-pointer"
          >
            <FontAwesomeIcon icon={faUser} className="h-4 w-4" />
            Account
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleSignOut}
          className="flex items-center gap-2 cursor-pointer text-destructive focus:text-destructive"
        >
          <FontAwesomeIcon icon={faRightFromBracket} className="h-4 w-4" />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
